import { Role } from './roles.interface'
import { GalvmanPlayerGuard } from '../galvman/certification/player.guard'

const KEYEorGALVMANSpecificRoutes = {
    certificationPlayerRoute: GalvmanPlayerGuard.isKEYEorGALVMAN
        ? [
              {
                  name: 'player',
                  route: ['/', 'galvman', 'certification', 'player'],
                  title: 'Player'
              }
          ]
        : []
}
export const GalvmanRole: Role = {
    name: 'galvman',
    title: 'Galvanic Treatment Supplier',
    icon: 'ion-ios-calculator',
    pages: [
        {
            title: 'Galvanic Treatment',
            name: 'galvanicTreatment',
            icon: 'ion-ios-refresh',
            children: [
                {
                    route: ['/', 'galvanic-treatment', 'prepare'],
                    title: 'Prepare',
                    name: 'prepare'
                },
                {
                    route: ['/', 'galvanic-treatment', 'manage'],
                    title: 'Manage',
                    name: 'manage'
                },
                {
                    route: ['/', 'galvanic-treatment', 'view'],
                    title: 'View',
                    name: 'view'
                }
            ]
        },
        {
            route: ['/', 'galvman', 'plating-materials'],
            title: 'Plating Materials',
            name: 'platingMaterials',
            icon: 'ion-ios-paper'
        },
        {
            route: ['/', 'galvman', 'data-sheets'],
            title: 'Data Sheets',
            name: 'dataSheets',
            icon: 'ion-ios-paper'
        },
        {
            route: ['/', 'galvman', 'history', 'galvanic-treatment'],
            title: 'History',
            name: 'history',
            icon: 'ion-ios-clock'
        },
        {
            title: 'Certification',
            name: 'certification',
            icon: 'ion-document-text',
            children: [
                {
                    name: 'select-and-create',
                    route: ['/', 'galvman', 'certification', 'select-and-create'],
                    title: 'Select and Create'
                },
                {
                    name: 'upload-and-create',
                    route: ['/', 'galvman', 'certification', 'upload-and-create'],
                    title: 'Upload and Create'
                },
                ...KEYEorGALVMANSpecificRoutes.certificationPlayerRoute,
                {
                    name: 'view',
                    route: ['/', 'galvman', 'certification', 'view'],
                    title: 'View'
                },
                {
                    name: 'plating-material',
                    route: ['/', 'galvman', 'certification', 'plating-material'],
                    title: 'Plating Material'
                }
            ]
        }
        // {
        //   route: ['/', 'cmpman', 'history', 'eyewear'],
        //   title: 'History',
        //   name: 'history',
        //   icon: 'ion-ios-clock'
        // }
    ],
    modules: {
        commonModules: [
            // {
            //   path: 'component',
            //   name: 'ComponentModule'
            // }  ,
            // {
            //   path: 'history',
            //   url: 'galvman/history',
            //   name: 'HistoryModule'
            // },
            {
                path: 'galvanic-treatment',
                // url: '',
                name: 'GalvanicTreatmentPmvModule',
                load: () =>
                    import('../galvman/galvanic-treatment/galvanic-treatment.module').then(
                        m => m.GalvanicTreatmentPmvModule
                    )
            },
            {
                path: 'data-sheets',
                url: 'galvman/data-sheets',
                name: 'GtDataSheetModule',
                load: () => import('../galvman/data-sheets/data-sheets.module').then(m => m.GtDataSheetModule)
            },
            {
                path: 'plating-materials',
                url: 'galvman/plating-materials',
                name: 'PlatingMaterialsModule',
                load: () =>
                    import('../galvman/plating-materials/plating-materials.module').then(m => m.PlatingMaterialsModule)
            },
            {
                path: 'certification',
                url: 'galvman/certification',
                name: 'CertificationModule',
                load: () => import('../galvman/certification/certification.module').then(m => m.CertificationModule)
            },
            {
                path: 'history',
                url: 'galvman/history',
                name: 'HistoryModule',
                load: () => import('../galvman/history/history.module').then(m => m.HistoryModule)
            }
        ],
        externalModules: [
            // {
            //   path: 'cmpman/mapping',
            //   childPath: 'base-material',
            //   component: MappingBaseMaterialComponent,
            //   resolveOrganizations: true,
            //   resolveHandbook: true
            // }
        ]
    }
}
